if($('.id--18').length){
    var codeString = $('.breadcrumbs span#navigation-2 meta[itemprop="item"]').attr('content').split('code=')[1];
    fetch('https://php.shopcode.cz/api/prolicence/apitoken.php?order='+codeString)
    .then(res => res.json())
    .then(data => {
        if (!data.success || !data.raw?.processed) return;
        const products = data.raw.products || [];
        products.forEach(product => {

            const code = product.product_code;

            // 🔥 najdi řádek podle kódu
            const $row = $('.p-name__code').filter(function () {
                return $(this).text().trim() === code;
            }).closest('tr');

            if (!$row.length) return;

            // 🔥 přidej box s licencí
            const licenseHtml = `
                <div class="licenseBox" style="margin-top:10px; padding:10px; border:1px solid #eee; border-radius:6px;">
                    <strong>Licenční klíč:</strong><br>
                    <code style="font-size:14px;">${product.value}</code>
                </div>
            `;

            $row.find('.p-name').append(licenseHtml);

        });

    });


}